const projectcategory = {
    getlist: 'projectcategory/getlist',
    add: 'projectcategory/add',
    update: 'projectcategory/update',
    remove: 'projectcategory/remove',
    get: 'projectcategory/get',
    getall: 'projectcategory/getall',
    clearcache: 'projectcategory/clear-cache',
}
export default projectcategory
